import _ from 'lodash';

export default function getUserDataStringFromMetadata(user, medicalGroups, specialties) {
  const filteredMedicalGroups = medicalGroups.filter(
    mg => mg.id === user.medicalGroupId);
  const medicalGroup = _.isEmpty(filteredMedicalGroups) ? {} : filteredMedicalGroups[0];

  const filteredSpecialties = specialties.filter(
    sp => sp.id === user.specialtyId);
  const specialty = _.isEmpty(filteredSpecialties) ? {} : filteredSpecialties[0];
  return {
    specialty,
    medicalGroup,
  };
}



// WEBPACK FOOTER //
// ./src/utils/getUserDataStringFromMetadata.js